var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgQrCodeMobile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 43,
    height: 43,
    rx: 11.5,
    stroke: "#5062F0"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 14.3,
    y: 16.4443,
    width: 2.2,
    height: 11.1111,
    rx: 1,
    fill: "#010311"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 17.6,
    y: 16.4443,
    width: 2.2,
    height: 11.1111,
    rx: 1,
    fill: "#010311"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 27.5,
    y: 16.4443,
    width: 2.2,
    height: 11.1111,
    rx: 1,
    fill: "#010311"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 20.9,
    y: 16.4443,
    width: 3.3,
    height: 11.1111,
    rx: 1.65,
    fill: "#010311"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 25.3,
    y: 16.4443,
    width: 1.1,
    height: 11.1111,
    rx: 0.55,
    fill: "#010311"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.4 32H30C31.6569 32 33 30.6569 33 29V25.3333",
    stroke: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11 25.3333V28.9999C11 30.6568 12.3431 31.9999 14 31.9999H18.7",
    stroke: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M33 18.6667V15.0001C33 13.3432 31.6569 12.0001 30 12.0001H25.3",
    stroke: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M17.6 12H14C12.3431 12 11 13.3431 11 15V18.6667",
    stroke: "#010311"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQrCodeMobile);
export default __webpack_public_path__ + "static/media/qrCodeMobile.f1ead998ffa6cc40c02528e17320a136.svg";
export { ForwardRef as ReactComponent };